import styled from 'styled-components';

export const StyledContainer = styled.div`
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    width: 100vw;
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
`;
